<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Products</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm()"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Product
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Product
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div style="display:flex">
                <b-form-input
                id="filter-input"
                v-model="searchTerm"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
              <b-button style="border:1px solid #ccc;" @click="filter = searchTerm">Filter</b-button>
              </div>

            </div>
            <div class="col-md-6">
              <select
            class="form-control"
            v-model="category"
            name="category_id"
            style="width: 100%;"
            @change="refreshTable"
          >
            <option id="category" selected value=""
              >Choose Category</option
            >
            <option
              v-for="category in categoryList"
              :key="category.category_id"
              v-bind:value="category.category_id"
              >{{ category.category_name }}</option
            >
          </select>
            </div>
          </div>
          <hr/>
          
            <div class="co-md-12">
                <b-table id="item-table"
                  :items="filteredList" 
                  ref="table"
                  primary-key="product_id"
                  :fields="fields"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :filter="filter"
                  hover
                  :per-page="perPage"
                  :current-page="currentPage">
                  <!-- A virtual column -->
                  <template #cell(sno)="data">
                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                  </template>
                  <template #cell(action)="data">
                    <a
                      v-on:click="showForm(data.item.product_id)"
                      class="btn label-warning btn-xs"
                      style="width: 100%;margin-bottom: 3px;;"
                      ><i class="fa fa-edit"></i> Edit</a
                    ><a v-if="isAdmin"
                      v-on:click="deleteProduct(data.item.product_id)"
                      class="btn label-danger btn-xs"
                      style="width: 100%;"
                      ><i class="fa fa-trash"></i> Delete</a
                    >
                  </template>
                </b-table>
              <!-- Show pagination links -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="item-table"
                  hide-ellipsis
                  ></b-pagination>
            </div>
        </div>
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Product
          </h4>
        </template>
        <template #body>
          <AddProduct
            :productId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddProduct from "../components/AddProduct.vue";
import PanelModal from "../components/PanelModal.vue";
import { BTable, BPagination, BFormInput, BButton } from 'bootstrap-vue'

export default {
  name: "Product",

  components: {
    AddProduct,
    PanelModal,
    BPagination,
    BTable,
    BFormInput,
    BButton
  },
  data() {
    return {
      isBusy: false,
      productName: '',
      searchTerm: null,
      categoryList: [],
      category: "",
      showFormModal: false,
      itemList: [],
      itemId: "",
      filter: null,
      filterOn: ['product_name', 'brand_name', 'category_name'],
      perPage: 10,
      currentPage: 1,
     // totalRows: 1,
      filteredCount: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'product_name', label: 'Product'},
        { key:'price', label: 'Price'},
        { key:'brand_name', label: 'Brand'},
        { key:'category_name', label: 'Category'},
        { key:'action', label: 'Actions'},
        ]
    };
  },
  computed: {
    isAdmin: function () {
        if (this.$store.state.user && this.$store.state.user.user_role == this.$store.state.userroleAdmin) {
            return true
        } else {
            return false
        }
    },
    filteredList: function () {
     const list = this.itemList.filter((item) => {
       return this.category ? item.category_id == this.category : true
     });
     return list
    },
    totalRows: function () {
      return this.filter && this.filter.length ? this.filteredCount : this.filteredList.length
    }
  },
  methods: {
    refreshTable: function () {
      this.$refs.table.refresh()
    },
    getCategory: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    itemProvider() {
      let items = []
      const list = {
        filter: {
          'product_name': this.productName
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.itemList = response.data.values;
          } else {
            this.itemList = data.productList;
            items = this.itemList
            // this.totalRows = this.itemList.length
            // this.$refs.table.refresh();
            return data.productList;
          }
        });
      return items || []
    },
    getList: function() {
      const list = {
        filter: {
          'product_name': this.productName
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.productList;
           // this.totalRows = this.itemList.length
          }
        });
    },
    showForm: function(productid) {
      this.itemId = productid;
      this.showFormModal = true;
    },
    deleteProduct(productId) {
      const formData = {
        "product-form": {
          product_id: productId
        },
      };
      api
        .request("post", "GeneralApis/change_product_status", formData)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.response = data.errormessage;
            return;
          } else {
            alert("Item Deleted Successfully!");
            this.itemList = data.productList;
          }
        });
    },
      onFiltered(filteredItems) {
        this.filteredCount = filteredItems.length
        this.currentPage = 1
      }
  },
  mounted(){
    this.getList()
    this.getCategory();
  }
};
</script>
